import React, { useContext, useEffect, useState } from "react";
import { Heading, RichTextEditor, SectionHeading, SectionSamples } from "../../../components";
import Input from "../../../components/Input/Input";
import { ResumeContext } from "../../../contexts/resumeContext";
import { deleteIcon, Plus } from "../../../components/Icons/Icons";

function InternshipForm() {
  const newInternshipBlock = {
    jobTitle: "",
    company: "",
    startDate: "",
    endDate: "",
    location: "",
    description: "",
  };

  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);

  const [internshipDetails, setInternshipDetails] = useState(
    Object.values(
      resumeInfo?.misc?.internships || { 0: { ...newInternshipBlock } }
    ) || []
  );

  useEffect(() => {
    const miscSection = { ...resumeInfo.misc };
    miscSection["internships"] = internshipDetails;

    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [internshipDetails]);

  const handleChange = (e, ix) => {
    let internshipDetailsArr = [...internshipDetails];
    let internshipDetailsObj = internshipDetailsArr[ix];
    internshipDetailsObj[e.target.name] = e.target.value;
    internshipDetailsArr[ix] = internshipDetailsObj;
    setInternshipDetails(internshipDetailsArr);
  };

  const addBlock = () => {
    let internshipArr = [...internshipDetails, newInternshipBlock];
    setInternshipDetails(internshipArr);
  };

  const deleteBlock = (ix) => {
    const internshipArr = [...internshipDetails];
    internshipArr.splice(ix, 1);
    setInternshipDetails(internshipArr);
  };

  return (
    <div>
      <SectionHeading editable content="Internship" section="INT" subheading={<><SectionSamples section="INT"/></>} />
      {internshipDetails.map((exp, ix) => (
        <div className="block" key={`ed_${ix}`}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}>
            <img src={deleteIcon} />
          </button>
          <div className="row">
            <div className="col">
              <Input
                label="Job Title"
                name="jobTitle"
                onChange={(e) => handleChange(e, ix)}
                value={exp.jobTitle}
              />
            </div>
            <div className="col">
              <Input
                label="Company/Employer"
                name="company"
                onChange={(e) => handleChange(e, ix)}
                value={exp.company}
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <Input
                label="Start Date"
                name="startDate"
                type="month"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={exp.startDate}
              />
            </div>
            <div className="col">
              <Input
                label="End Date"
                name="endDate"
                type="month"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={exp.endDate}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Location"
                name="location"
                onChange={(e) => handleChange(e, ix)}
                value={exp.location}
              />
            </div>
          </div>
          <div className="row">
            <RichTextEditor
              placeholder="Write 4-5 crisp bullets. Take care to mention numbers and figures. Bold appropritate text to highlight important things"
              value={exp.description}
              onChange={(value) =>
                handleChange({ target: { name: "description", value } }, ix)
              }
            />
          </div>
        </div>
      ))}
      <button className="link" onClick={addBlock}>
        Add More Internship <Plus />
      </button>
    </div>
  );
}

export default InternshipForm;
